import { useEffect, useState } from 'react';
import Pagination from '../../../../components/Shared/Pagination/Pagination';
import { Card, CardBody } from '../../../../components/card/card';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { Link, useNavigate } from 'react-router-dom';
import { GetNtxPeoplesList } from '../../../../store/NTX/Peoples/peoplesSlice';
 import AddSuppliers from './AddSuppliers';
import Loader from '../../../../components/Shared/Loader/Loader';
import ModalComponent from '../../../../components/Modal/ModalComponent';

const Index = () => {
  const [Show, setShow] = useState(false);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(10);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();

  useEffect(() => {
    dispatch(GetNtxPeoplesList(''));
  }, []);
  const { PeoplesList, loading } = useAppSelector((state) => state.Peoples);

  const filteredSearch = PeoplesList?.slice()
    ?.filter((emp) => {
      const searchLowerCase = search.toLowerCase();
      return (
        emp.name?.toLowerCase().includes(searchLowerCase) ||
        emp.name2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter((f) => f.typeCode === 'SUPPLIERS');

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);
  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome',
    },
    {
      name: 'Suppliers',
      link: null,
    },
  ];

  return (
    <div>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="Suppliers" />

        <div className="ms-auto">
          <Link
            to=""
            className="btn me-1 btn-outline-theme"
            data-bs-toggle="modal"
            data-bs-target="#modalِAddSuppliers"
            onClick={() => setShow(true)}>
            <i className="fa fa-plus-circle fa-fw me-1"></i>
            {t('AddSuppliers')}
          </Link>
        </div>
      </div>

      <Card>
        {/* <Loading loading={loading} error={error} SkeletonType="Table"> */}
        <Loader loading={loading} />

        <CardBody>
          <div className="tab-content p-2">
            <div className="row">
              <div className="col-7 col-md-6 d-flex justify-content-start">
                <div className="input-group mb-4">
                  <div className="flex-fill position-relative">
                    <div className="input-group">
                      <div
                        className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
                         >
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control ps-35px"
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder={t('Search') + ' ...'}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* //  START TABLE   */}
            <div className="table-responsive">
              <table className="table">
                <thead className="table-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">{t('Name')}</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {currentData?.map((item, index) => (
                    <tr key={item.id}>
                      <td className="align-middle">{++index}</td>
                      <td className="align-middle">
                        {i18n.language === 'en' ? item.name : item.name2}
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-outline-lime"
                          onClick={() => Navigate(`${item.id}/Edit`)}>
                          <i className="far fa-lg fa-fw me-2 fa-edit"></i>
                          {t('Button.Edit')}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination
              filteredData={filteredSearch}
              dataPerPage={dataPerPage}
              handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
              currentPage={currentPage}
            />
          </div>
        </CardBody>
        {/* </Loading> */}
      </Card>

      <ModalComponent title={t('AddSuppliers')} id="modalِAddSuppliers">
        {Show && <AddSuppliers />}
      </ModalComponent>
    </div>
  );
};

export default Index;
